module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug-block"
  }, [_c('button', {
    staticClass: "debug-block__trigger",
    class: ("debug-block__trigger--" + _vm.position),
    on: {
      "click": _vm.btnClick
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowEntry),
      expression: "isShowEntry"
    }],
    staticClass: "debug-block__entry absolute-y-middle"
  }, [_c('button', {
    staticClass: "debug-block__close",
    on: {
      "click": function($event) {
        _vm.isShowEntry = false
      }
    }
  }, [_c('span', [_vm._v("X")])]), _vm._v(" "), _c('url-input', {
    attrs: {
      "test-server": "http://192.168.2.201:8080"
    }
  }), _vm._v(" "), _c('console-button')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a903c1c2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/items/DebugBlock/index.vue
// module id = 921
// module chunks = 1